//#region DevExtreme Imports

import 'devextreme/ui/form'

//#endregion

import { USER_SESSION_SERVICE_NAME } from "../../../services/user-session"

import { IMRBaseComponent } from '../base'

import { IMRServicemanController } from './serviceman.controller'

//#region Asset Imports

import './serviceman.scss'
import * as TEMPLATE from './serviceman.tpl.html'

//#endregion

export const COMPONENT_NAME: string = 'imrServiceman'

export class IMRServicemanComponent extends IMRBaseComponent {

    constructor() {
        super({
            controller: IMRServicemanController,
            services: [USER_SESSION_SERVICE_NAME],
            template: TEMPLATE
        })
    }
}